import { useState } from "react"
import useEcoClient from "./useEcoClient";

/**
 * Hooks for uploading file to backend
 */
const useUpload = () => {
    
    const ecoClient = useEcoClient();
    const [progress, setProgress] = useState<number>(0)

    const upload = async (file: File, docTp: string = 'LOGO'): Promise<UploadFileResponseType> => {
        const limit = parseInt(process.env.REACT_APP_LOGIN_UPLOAD_LIMIT as string)
        if (file.size > limit) {
            throw new Error(`FILE_TOO_LARGE`)
        }

        const response = await ecoClient.post<Record<string, any>>({
            path: 'entityDoc.new',
            data: { upload: file, docTp },
            config: {
                onUploadProgress: (progressEvent: any) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    setProgress(percentCompleted)
                }
            }
        })

        return  {
            cached: response.cached,
            docFilename: response.doc_filename,
            docId: response.doc_id,
            message: response.msg,
            sharingKey: response.sharing_key,
            success: response.success
        }
    }

    return {
        progress,
        setProgress,
        upload
    }
}

type UploadFileResponseType = {
    /** Flag telling if file is cached on the server */
    cached: boolean,
    /** Uploaded file name */
    docFilename: string
    /** Uploaded file Id */
    docId: number
    /** Uploaded message text */
    message: string
    /** Blob sharing key  */
    sharingKey: string,
    /** Flag telling if operation successed */
    success: boolean
}


export default useUpload